<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
const props = defineProps({
  title: { type: String, required: true },
  busy: Boolean,
});
const emit = defineEmits(['close']);
const { t } = useI18n();
const dialog = ref(null);
onMounted(() => dialog.value.showModal());
function close() {
  if (!props.busy) emit('close');
}
</script>

<template>
  <Teleport to="body">
    <dialog
      ref="dialog"
      :aria-label="title"
      class="fixed inset-y-0 left-auto right-0 m-0 h-full max-h-full w-full max-w-xl border-0 border-l border-n-weak bg-n-solid-2 p-0 text-n-slate-12 backdrop:bg-black/30"
      @cancel.prevent="close"
      @close="close"
    >
      <div class="flex h-full min-h-0 flex-col">
        <header
          class="flex shrink-0 items-center justify-between gap-3 border-b border-n-weak p-4"
        >
          <h2 class="m-0 min-w-0 break-words text-base font-semibold">
            {{ title }}
          </h2>
          <Button
            icon="i-lucide-x"
            variant="ghost"
            color="slate"
            :aria-label="t('MEDIA_LIBRARY.CLOSE')"
            :title="t('MEDIA_LIBRARY.CLOSE')"
            :disabled="busy"
            @click="close"
          />
        </header>
        <div class="min-h-0 flex-1 overflow-y-auto"><slot /></div>
      </div>
    </dialog>
  </Teleport>
</template>
